import { btnOne } from "../utils/style";


function Call({setShowModal, setShowCallModal, phone}) {

    return(
        <div className="flex w-screen h-screen fixed top-0 left-0 items-center justify-center bg-black z-50 bg-opacity-50" onClick={() => setShowModal(false)}>
            <div className="flex flex-col gap-4 px-4 rounded-xl py-6 bg-white w-full text-center pb-24 fixed bottom-0">
                <div className={btnOne} onClick={() => setShowCallModal(true)}>Internet Call</div>
                <a className={btnOne} href={`tel:${phone}`}>Regular Call</a>
            </div>
        </div>
    )
}
export default Call;